import { COUNTRY_DIALING_CODES } from "shared/dictionaries/countryDialingCodes";

export const isOnlyDigitsOrEmpty = (str) => /^\d*$/.test(str);

export const dialingCodeFormatter = ({ countryName, isoCode, dialingCode }) => ({
	name: `${countryName} +${dialingCode}`,
	dialingCode,

	// no country names contain _ so it is safe to: const [isoCode, dialingCode] = value.split("_");
	value: `${isoCode}_${dialingCode}`,
});

export const DIALING_CODE_SELECT_OPTIONS = COUNTRY_DIALING_CODES.map(dialingCodeFormatter);

export const getDefaultDialingCode = (countryCode) => {
	const defaultOption = { isoCode: "US", dialingCode: "1" };

	const { isoCode, dialingCode } = COUNTRY_DIALING_CODES
		.find((option) => option.isoCode === countryCode) || defaultOption;

	return { isoCode, dialingCode };
};



// WEBPACK FOOTER //
// ./src/shared/components/PhoneInput/helpers.js